<template lang="pug">
.eracing-mainmarket-group
  .eracing-mainmarket-item.collapsed(
    v-if="source.items != null && source.items[0] != null && source.items.length == 7"
    type='button' 
    :id="source.items[0].id"
    data-toggle='collapse' 
    :data-target="'#mainmarket-' + source.items[0].matchId"
  )
    //- .row.m-0.align-items-center
    efTimer(:source="source.items[0]" :horiz="true" :class="{ 'd-none' : source.items[0].marketId == 3 }")
      //- .mr-2.time-remaining.red-text
      //-   i.far.fa-stopwatch
      //-   span 58s
    .live-icon-wrapper(:class="{ 'd-none' : source.items[0].marketId != 3 }")
      img.live-icon(src='images/egame/live-icon.svg')
      span.mx-1 LIVE
      .live-dot
  .collapse.show(
    :id="'mainmarket-' + source.items[0].matchId"
  )
    .match-collapse-body
      //- small {{ source.items }}
      .winners-market.mb-1
        .player-wrapper
          .d-flex.align-items-center.justify-content-center.mt-2.mb-2.player-info-wrapper
            img.characters(src='images/egame/crown/no1.svg')
            .ml-2.player-name-wrapper
              | {{ $t("ui.no1") }}
          .d-flex.align-items-center.mb-1
            .eracing-odds.flex-grow-1
              template(v-if="source.items[6] && source.items[6].details['ou'] && source.items[6].details['ou'][0] && source.items[6].details['ou'][0][11] != 0 && source.items[6].details['ou'][0][12] != 0 && source.items[6].details['ou'][0][11] != '' && source.items[6].details['ou'][0][12] != ''")
                OddsItem(:odds="source.items[6].details['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" count=0 :details="source.items[6].details" homeAway="1")
              template(v-else)
                OddsDisabled
            .eracing-odds.flex-grow-1
              template(v-if="source.items[6] && source.items[6].details['ou'] && source.items[6].details['ou'][0] && source.items[6].details['ou'][0][11] != 0 && source.items[6].details['ou'][0][12] != 0 && source.items[6].details['ou'][0][11] != '' && source.items[6].details['ou'][0][12] != ''")
                OddsItem(:odds="source.items[6].details['ou'][0]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" count=0 :details="source.items[6].details" homeAway="2")
              template(v-else)
                OddsDisabled
            .eracing-odds.flex-grow-1
              template(v-if="source.items[6] && source.items[6].details['oe'] && source.items[6].details['oe'][0] && source.items[6].details['oe'][0][5] != 0 && source.items[6].details['oe'][0][5] != ''")
                OddsItem(:odds="source.items[6].details['oe'][0]" idx=5 :typ="oddsType" dataType="2" label="odd")
              template(v-else)
                OddsDisabled
            .eracing-odds.flex-grow-1
              template(v-if="source.items[6] && source.items[6].details['oe'] && source.items[6].details['oe'][0] && source.items[6].details['oe'][0][7] != 0 && source.items[6].details['oe'][0][7] != ''")
                OddsItem(:odds="source.items[6].details['oe'][0]" idx=7 :typ="oddsType" dataType="2" label="even")
              template(v-else)
                OddsDisabled
      .d-flex.justify-content-end.align-items-center.bettype-row
        .bettype-col {{ $t("m.GH_1X20") }}
        .bettype-col {{ $t("m.GH_1X2HDP2") }}
        .bettype-col {{ $t("m.GH_1X2HDP4") }}
      template(v-for="(x, i) in source.items.slice(0, -1)")
        .d-flex.justify-content-between.align-items-center.player-wrapper
          .d-flex.player-info-wrapper
            img.characters(:src="getImage(x)")
            .ml-2.player-name-wrapper
              .player-name.mt-1 {{ team(x, 1) }}
              //- .small-text.purple-text
              //-   .box T
              //-   | J Turner
          .d-flex.justify-content-center.align-items-center
            template(v-if="source.items[0].marketId == 3")
              .eracing-odds
                OddsDisabled
              .eracing-odds
                OddsDisabled
              .eracing-odds
                OddsDisabled
            template(v-else)
              .eracing-odds
                template(v-if="x.details['oxt'] && x.details['oxt'][0] && x.details['oxt'][0][5] != 0 && x.details['oxt'][0][5] != ''")
                  OddsItem(:odds="x.details['oxt'][0]" idx=5 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled
              .eracing-odds
                template(v-if="x.details['tw'] && x.details['tw'][1] && x.details['tw'][1][5] != 0 && x.details['tw'][1][5] != '' && x.details['tw'][1][17] == 2")
                  OddsItem(:odds="x.details['tw'][1]" idx=5 :typ="oddsType" dataType="2")
                template(v-else)
                  template(v-if="x.details['tw'] && x.details['tw'][0] && x.details['tw'][0][5] != 0 && x.details['tw'][0][5] != '' && x.details['tw'][0][17] == 2")
                    OddsItem(:odds="x.details['tw'][0]" idx=5 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled
              .eracing-odds
                template(v-if="x.details['tw'] && x.details['tw'][0] && x.details['tw'][0][5] != 0 && x.details['tw'][0][5] != '' && x.details['tw'][0][17] == 4")
                  OddsItem(:odds="x.details['tw'][0]" idx=5 :typ="oddsType" dataType="2")
                template(v-else)
                  template(v-if="x.details['tw'] && x.details['tw'][1] && x.details['tw'][1][5] != 0 && x.details['tw'][1][5] != '' && x.details['tw'][1][17] == 4")
                    OddsItem(:odds="x.details['tw'][1]" idx=5 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled
</template>

<script>
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    efTimer: () => import("@/components/mobile/efight/efTimer"),
    OddsItem: () => import("@/components/mobile/main/xitem/oddsItem"),
    OddsDisabled: () => import("@/components/mobile/main/xitem/oddsDisabled")
  },
  mixins: [mixinHDPOUOdds],
  props: {
    source: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: { 
    oddsType() {
      return this.$store.getters.pageDisplay.oddsType;
    }
   },
  methods: {
    team(player, pos) {
      var n = player.homeTeam.split(" - ")[pos];
      return n;
    },
    getImage(x) {
      return "images/egame/marble-characters/ball" + String(this.team(x, 0)) +".svg";
    }
  }
};
</script>